import React from 'react';
import TeamResult from './Team';

export default {
  name: 'Teams',
  render: (team, props) => <TeamResult key={team.id} {...team} {...props} />,
  resultKey: 'teams',
  type: 'team',
};
